/* eslint-disable react-hooks/exhaustive-deps */

import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ allowedRoles, access, children }) => {
    const userRole = useSelector((state) => state.auth.role);
    const location = useLocation();

    // Role check
    if (!allowedRoles.includes(userRole)) {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }


   // Permission check  
    if (access === "None") {
        return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
    return children;
};

export default ProtectedRoute;